module.exports = __webpack_public_path__ + "img/file-upload.329e3d87.svg";